import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { isAuthenticated, token } = useAuth();
  
  // WebSocket deaktiviert - keine automatische Verbindung
  useEffect(() => {
    setSocket(null);
    setConnected(false);
  }, []);

  const addNotification = (notification) => {
    setNotifications(prev => [...prev, { ...notification, id: Date.now() }]);
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  };

  const emit = (event, data) => {
    // WebSocket deaktiviert - keine Emit-Funktionalität
    console.log('Emit disabled:', event, data);
  };

  const subscribe = (event, callback) => {
    // WebSocket deaktiviert - keine Subscribe-Funktionalität
    console.log('Subscribe disabled:', event);
    return () => {}; // Return empty unsubscribe function
  };

  const value = {
    socket,
    connected,
    notifications,
    addNotification,
    removeNotification,
    emit,
    subscribe,
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};